import { jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Responsive grid layout component
 * @param children - Grid items
 * @param className - Additional CSS classes
 * @param cols - Number of columns (default)
 * @param gap - Gap size between grid items
 * @param responsive - Responsive column configuration
 * @returns JSX element with grid layout
 */
const Grid = ({ children, className, cols = 1, gap = 'md', responsive, }) => {
    const colsClasses = {
        1: 'grid-cols-1',
        2: 'grid-cols-2',
        3: 'grid-cols-3',
        4: 'grid-cols-4',
        5: 'grid-cols-5',
        6: 'grid-cols-6',
        12: 'grid-cols-12',
    };
    const responsiveColsClasses = {
        1: {
            sm: 'sm:grid-cols-1',
            md: 'md:grid-cols-1',
            lg: 'lg:grid-cols-1',
            xl: 'xl:grid-cols-1',
        },
        2: {
            sm: 'sm:grid-cols-2',
            md: 'md:grid-cols-2',
            lg: 'lg:grid-cols-2',
            xl: 'xl:grid-cols-2',
        },
        3: {
            sm: 'sm:grid-cols-3',
            md: 'md:grid-cols-3',
            lg: 'lg:grid-cols-3',
            xl: 'xl:grid-cols-3',
        },
        4: {
            sm: 'sm:grid-cols-4',
            md: 'md:grid-cols-4',
            lg: 'lg:grid-cols-4',
            xl: 'xl:grid-cols-4',
        },
        5: {
            sm: 'sm:grid-cols-5',
            md: 'md:grid-cols-5',
            lg: 'lg:grid-cols-5',
            xl: 'xl:grid-cols-5',
        },
        6: {
            sm: 'sm:grid-cols-6',
            md: 'md:grid-cols-6',
            lg: 'lg:grid-cols-6',
            xl: 'xl:grid-cols-6',
        },
        12: {
            sm: 'sm:grid-cols-12',
            md: 'md:grid-cols-12',
            lg: 'lg:grid-cols-12',
            xl: 'xl:grid-cols-12',
        },
    };
    const gapClasses = {
        none: 'gap-0',
        sm: 'gap-2',
        md: 'gap-4',
        lg: 'gap-6',
        xl: 'gap-8',
    };
    const responsiveClasses = responsive
        ? [
            responsive.sm && responsiveColsClasses[responsive.sm].sm,
            responsive.md && responsiveColsClasses[responsive.md].md,
            responsive.lg && responsiveColsClasses[responsive.lg].lg,
            responsive.xl && responsiveColsClasses[responsive.xl].xl,
        ].filter(Boolean)
        : [];
    return (jsx("div", { className: cn('grid', colsClasses[cols], gapClasses[gap], ...responsiveClasses, className), children: children }));
};

export { Grid };
//# sourceMappingURL=Grid.js.map
